import { createDataWidget } from "@/widgets/common/createDataWidget";
import { fetchDashboardMockData } from "../mockDashboard";
import type { AverageRateItem } from "../dashboardResponse";

/**
 * Widget state via the shared factory (D11): thunk + slice + selectors in
 * one declaration. The fetcher reads the `average_rate` section from the
 * page's dashboard response; swapping in CubeJS is a body-only change here.
 */
export const averageRatePie = createDataWidget<AverageRateItem>({
  name: "averageRatePie",
  fetcher: async () => {
    const response = await fetchDashboardMockData();
    return response.data.average_rate;
  },
});
